import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'sb-column-header',
    templateUrl: './column-header.component.html',
    styleUrls: ['./column-header.component.scss'],
    standalone: false
})
export class ColumnHeaderComponent {

  @Input() label: string;
  @Input() labelIconName: string;
  @Input() fieldName: string;
  @Input() sortType: string;
  @Output() sortTypeChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() sortReverse: boolean;
  @Output() sortReverseChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() toolTip: string;
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  click() {
    if (this.sortType) {
      this.sortType = this.fieldName;
      this.sortTypeChange.emit(this.sortType);
      this.sortReverse = !this.sortReverse;
      this.sortReverseChange.emit(this.sortReverse);
      // Emit AFTER the sortType/sortReverse two-way bindings have propagated so consumers that
      // re-query on (onClick) (e.g. server-side sorted tables calling getInvoices()) read the
      // updated sort. Mirrors the legacy sbColumnHeader, which fired on-click post-sort.
      this.onClick.emit();
    }
  }

  // Keyboard activation for the role="button" header. Only sortable headers are focusable
  // (tabindex set in the template), so this is a no-op otherwise. preventDefault stops Space
  // from scrolling the page.
  onActivateKey(event: Event): void {
    if (!this.sortType) {
      return;
    }
    event.preventDefault();
    this.click();
  }
}
